import { render, staticRenderFns } from "./mallPreference.vue?vue&type=template&id=28ff78af&scoped=true&"
import script from "./mallPreference.vue?vue&type=script&lang=js&"
export * from "./mallPreference.vue?vue&type=script&lang=js&"
import style0 from "./mallPreference.vue?vue&type=style&index=0&id=28ff78af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ff78af",
  null
  
)

export default component.exports